












export default {
  data: () => ({
    copyDate: new Date().getFullYear(),
  }),
} as IView;
